app.service('NHI', [function () {

    var service = {

        validate: function (nhi) {
            "use strict";

            // Must be a non-null string of length 7
            if (nhi === null || typeof nhi !== 'string' || nhi.length !== 7) {
                return false;
            }

            // Normalize
            var upperNhi = nhi.toUpperCase();

            // Enforce 3 letters (A-H, J-N, P-Z), then one of:
            //   � 4 digits
            //   � 2 digits + 2 letters
            //   � 3 digits + 1 letter
            var formatPattern = /^[A-HJ-NP-Z]{3}(?:\d{4}|\d{2}[A-HJ-NP-Z]{2}|\d{3}[A-HJ-NP-Z])$/;
            if (!formatPattern.test(upperNhi)) {
                return false;
            }

            // Always accept these test codes
            if (upperNhi === 'ZZZ9999' || upperNhi === 'ABC1234' || upperNhi === 'ABC1235') {
                return true;
            }

            // If it's the standard 3 letters + 4 digits, run checksum
            var numericPattern = /^[A-HJ-NP-Z]{3}\d{4}$/;
            if (numericPattern.test(upperNhi)) {
                var validCharacters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';

                var firstCharValue = validCharacters.indexOf(upperNhi.charAt(0)) + 1;
                var secondCharValue = validCharacters.indexOf(upperNhi.charAt(1)) + 1;
                var thirdCharValue = validCharacters.indexOf(upperNhi.charAt(2)) + 1;

                var digitOne = parseInt(upperNhi.charAt(3), 10);
                var digitTwo = parseInt(upperNhi.charAt(4), 10);
                var digitThree = parseInt(upperNhi.charAt(5), 10);
                var checkCharacter = parseInt(upperNhi.charAt(6), 10);

                if (isNaN(digitOne) || isNaN(digitTwo) || isNaN(digitThree) || isNaN(checkCharacter)) {
                    return false;
                }

                var sum = (firstCharValue * 7) +
                    (secondCharValue * 6) +
                    (thirdCharValue * 5) +
                    (digitOne * 4) +
                    (digitTwo * 3) +
                    (digitThree * 2);

                var checksum = sum % 11;
                if (checksum !== 0) {
                    var calculatedCheckDigit = 11 - checksum;
                    checksum = (calculatedCheckDigit === 10 ? 0 : calculatedCheckDigit);
                }

                return checksum === checkCharacter;
            }

            // Any other regex-matched variant (with letters in the numeric area) is accepted
            return true;
        }

    };

    return service;
}]);
